<template>
  <div class="row">
    <div class="col-md-4">
      <div class="bd-example d-flex justify-content-center">
        <div class="d-flex flex-column align-items-center">
          <div class="bd-placeholder-img img-thumbnail d-inline-block mb-3">
            <div
              :style="`height: 200px;width: 200px;background-color: #838b92;background-size: cover;` + (form.profile_url ? `background-image: url(${form.profile_url});` : '')"
              class="d-flex justify-content-center align-items-center">
              <Icon v-if="!form.profile_url" :icon="['fa', 'user']" style="color: white;"
                class="display-3 opacity-75" />
            </div>
          </div>

          <div class="mb-4" v-if="!readonly">
            <!-- <label for="foto-profile" class="form-label">Foto Profil</label> -->
            <input class="form-control form-control-sm" id="foto-profile" type="file"
              accept="image/png,image/jpg,image/jpeg" style="width: 200px;"
              @input="gambar = $event.target.files[0]; $emit('uploadGambar', gambar)">
            <!-- <button type="button" class="btn btn-sm btn-primary">Submit</button> -->
          </div>
          <small v-if="!readonly" class="fst-italic opacity-75">* Klik tombol simpan untuk melakukan perubahan setelah berhasil
            terupload!</small>
        </div>
      </div>
    </div>

    <div class="col">
      <form method="post" @submit.prevent="$emit('action', form)">
        <div class="mb-3">
          <label for="nama-lengkap" class="form-label">Nama Lengkap</label>
          <input type="text" class="form-control" :readonly="readonly" id="nama-lengkap" v-model="form.nama_lengkap">
        </div>
        <div class="mb-3">
          <label for="nip" class="form-label">Nomor Induk Pegawai (NIP)</label>
          <input type="text" class="form-control" :readonly="readonly" id="nip" v-model="form.nip">
        </div>
        <div class="mb-3">
          <label for="pangkat" class="form-label">Pangkat</label>
          <select :disabled="readonly" class="form-select" v-model="form.pangkat">
            <option value="">Pilih Pangkat</option>
            <option :value="r" v-for="(r, i) in master.pangkat" :key="`pangkat-${i}`" v-text="r"></option>
          </select>
        </div>
        <div class="mb-3">
          <label for="golongan" class="form-label">Golongan</label>
          <select :disabled="readonly" class="form-select" v-model="form.golongan">
            <option value="">Pilih Golongan</option>
            <option :value="r" v-for="(r, i) in master.golongan" :key="`golongan-${i}`" v-text="r"></option>
          </select>
        </div>
        <div class="mb-3">
          <label for="jabatan" class="form-label">Jabatan</label>
          <select :disabled="readonly" class="form-select" v-model="form.jabatan">
            <option value="">Pilih Jabatan</option>
            <option :value="r" v-for="(r, i) in master.jabatan" :key="`jabatan-${i}`" v-text="r"></option>
          </select>
        </div>
        <div class="mb-3">
          <label for="bidang" class="form-label">Bidang</label>
          <select :disabled="readonly" class="form-select" v-model="form.bidang">
            <option value="">Pilih Bidang</option>
            <option :value="r" v-for="(r, i) in master.bidang" :key="`bidang-${i}`" v-text="r"></option>
          </select>
        </div>
        <button v-if="!readonly" type="submit" class="btn btn-primary">Simpan Perubahan</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pegawai: Object,
    master: Object,
    readonly: Boolean
  },
  data() {
    return {
      old_gambar: {
        id: '',
        url: ''
      },
      gambar: null,
      form: {
        id: null,
        nama_lengkap: '',
        nip: '',
        pangkat: '',
        golongan: '',
        jabatan: '',
        bidang: '',
        profile_url: '',
        berkas_profile_id: ''
      },
    }
  },
  mounted() {
    const pangkat = (pg) => pg.substring(0, pg.length - pg.split('').reverse().indexOf(' ')).trim();
    if(this.pegawai) {
      this.form.id = this.pegawai.id;
      this.form.nama_lengkap = this.pegawai.nama_lengkap;
      this.form.nip = this.pegawai.nip;
      this.form.pangkat = pangkat(this.pegawai.pangkat_golongan);
      this.form.golongan = this.pegawai.pangkat_golongan.replace(pangkat(this.pegawai.pangkat_golongan), '').trim();
      this.form.jabatan = this.pegawai.jabatan;
      this.form.bidang = this.pegawai.bidang;
      this.form.berkas_profile_id = this.pegawai.berkas_profile_id;
      this.form.profile_url = this.pegawai.profile_url;
    }
  }
}
</script>